// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';

import crossMarkSvg from 'assets/icons/icon-src/markup/cross-mark.svg?raw';
import type { MarkupToolContext } from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';
import { makeStampConfig, type StampConfig } from 'components/Autodesk/extensions/MarkupModeExtension/StampMarkup';
import { CROSS_MARK_PATH_TOKENS } from 'components/Autodesk/extensions/MarkupModeExtension/stampPathTokens/crossMarkPathTokens';
import { StampTool } from 'components/Autodesk/extensions/MarkupModeExtension/StampTool';

const CROSS_MARK_CONFIG: StampConfig = makeStampConfig('crossMark', 'CROSS-MARK', CROSS_MARK_PATH_TOKENS);

export class CrossMarkTool extends StampTool {
  constructor(context: MarkupToolContext) {
    super(context, {
      type: 'crossMark',
      label: 'Cross Mark',
      iconSvg: crossMarkSvg,
      stampConfig: CROSS_MARK_CONFIG,
      defaults: {
        fillColor: '#CC0000' as HexTriplet, // Red color.
        stampSize: 24,
      },
    });
  }
}
